import { useState, useEffect } from 'react';
import { TaskProgress } from '../types/conversion.types';
import { getUrlWithToken } from '../utils/urlUtils';

export function useConversionTask(taskId: string | null) {
    const [progress, setProgress] = useState<TaskProgress>({
        status: 'pending',
        stage: '等待连接...',
        progress: 0,
    });

    useEffect(() => {
        if (!taskId) {
            setProgress({ status: 'pending', stage: '等待任务...', progress: 0 });
            return;
        }

        const baseUrl = import.meta.env.VITE_API_BASE_URL ?? '';
        const token = localStorage.getItem('auth_token');
        const streamUrl = getUrlWithToken(`${baseUrl}/api/v1/convert/tasks/${taskId}/stream`, token);
        const eventSource = new EventSource(streamUrl);

        eventSource.onopen = () => {
            console.log('SSE connection opened for task:', taskId);
        };

        const handleProgress = (event: MessageEvent) => {
            try {
                const data = JSON.parse(event.data);
                setProgress({
                    status: data.status,
                    stage: data.stage || '处理中...',
                    progress: data.progress || 0,
                    downloadUrl: data.download_url ? getUrlWithToken(`${baseUrl}${data.download_url}`, token) : undefined,
                    result_filename: data.result_filename,
                    error: data.error,
                    errorCode: data.error_code,
                });

                if (data.status === 'completed' || data.status === 'failed') {
                    eventSource.close();
                }
            } catch (err) {
                console.error('Failed to parse SSE event data', err);
            }
        };

        // Listen for specific event types based on status
        eventSource.addEventListener('pending', handleProgress);
        eventSource.addEventListener('processing', handleProgress);
        eventSource.addEventListener('completed', handleProgress);
        eventSource.addEventListener('failed', handleProgress);

        // Also listen to default message events
        eventSource.onmessage = handleProgress;

        eventSource.onerror = (err) => {
            console.error('SSE Error:', err);
            eventSource.close();
            setProgress((prev) => ({
                ...prev,
                status: 'disconnected',
                stage: '连接中断，请刷新重试',
                error: '网络连接断开',
            }));
        };

        return () => {
            eventSource.close();
        };
    }, [taskId]);

    return progress;
}
